/**
 * Centralized file-type icon mapping for Drive components.
 * Uses Font Awesome 4.7.0 classes + per-type colors.
 */

var ICON_MAP = [
  // Folders
  { test: function (m) { return m === 'application/vnd.google-apps.folder'; }, icon: 'fa-folder', color: '#F0C040' },

  // Google Workspace
  { test: function (m) { return m === 'application/vnd.google-apps.document'; }, icon: 'fa-file-text', color: '#4285F4' },
  { test: function (m) { return m === 'application/vnd.google-apps.spreadsheet'; }, icon: 'fa-file-excel-o', color: '#0F9D58' },
  { test: function (m) { return m === 'application/vnd.google-apps.presentation'; }, icon: 'fa-file-powerpoint-o', color: '#F4B400' },
  { test: function (m) { return m === 'application/vnd.google-apps.form'; }, icon: 'fa-list-alt', color: '#7627BB' },
  { test: function (m) { return m === 'application/vnd.google-apps.drawing'; }, icon: 'fa-paint-brush', color: '#DB4437' },
  { test: function (m) { return m === 'application/vnd.google-apps.site'; }, icon: 'fa-globe', color: '#4285F4' },
  { test: function (m) { return m === 'application/vnd.google-apps.jam'; }, icon: 'fa-object-group', color: '#F4B400' },
  { test: function (m) { return m === 'application/vnd.google-apps.map'; }, icon: 'fa-map-marker', color: '#0F9D58' },
  { test: function (m) { return m === 'application/vnd.google-apps.shortcut'; }, icon: 'fa-external-link', color: '#999' },

  // PDF
  { test: function (m) { return m === 'application/pdf'; }, icon: 'fa-file-pdf-o', color: '#DB4437' },

  // Microsoft Office
  { test: function (m) { return m.indexOf('wordprocessingml') !== -1 || m === 'application/msword'; }, icon: 'fa-file-word-o', color: '#2B579A' },
  { test: function (m) { return m.indexOf('spreadsheetml') !== -1 || m === 'application/vnd.ms-excel'; }, icon: 'fa-file-excel-o', color: '#217346' },
  { test: function (m) { return m.indexOf('presentationml') !== -1 || m === 'application/vnd.ms-powerpoint'; }, icon: 'fa-file-powerpoint-o', color: '#D24726' },

  // Images
  { test: function (m) { return m.indexOf('image/') === 0; }, icon: 'fa-file-image-o', color: '#DB4437' },

  // Video
  { test: function (m) { return m.indexOf('video/') === 0; }, icon: 'fa-file-video-o', color: '#DB4437' },

  // Audio
  { test: function (m) { return m.indexOf('audio/') === 0; }, icon: 'fa-file-audio-o', color: '#F4B400' },

  // Archives
  { test: function (m) { return m.indexOf('zip') !== -1 || m.indexOf('archive') !== -1 || m.indexOf('compressed') !== -1 || m.indexOf('tar') !== -1 || m.indexOf('rar') !== -1 || m.indexOf('7z') !== -1; }, icon: 'fa-file-archive-o', color: '#F4B400' },

  // Code / markup
  { test: function (m) { return m.indexOf('json') !== -1 || m.indexOf('xml') !== -1 || m.indexOf('html') !== -1 || m.indexOf('javascript') !== -1 || m.indexOf('css') !== -1 || m.indexOf('script') !== -1; }, icon: 'fa-file-code-o', color: '#4285F4' },

  // CSV
  { test: function (m) { return m === 'text/csv'; }, icon: 'fa-file-excel-o', color: '#217346' },

  // Plain text / rich text
  { test: function (m) { return m.indexOf('text/') === 0; }, icon: 'fa-file-text-o', color: '#666' },
];

var DEFAULT_ICON = { icon: 'fa-file-o', color: '#999' };

/**
 * Resolve icon info for a file.
 * @param {Object} file - { mimeType, isFolder, fileExtension }
 * @returns {{ iconClass: string, color: string }}
 */
function getFileIconInfo(file) {
  if (file.isFolder) {
    return { iconClass: 'fa fa-folder', color: '#F0C040' };
  }

  var mime = (file.mimeType || '').toLowerCase();

  // Extension-based fallbacks when MIME is generic
  var ext = (file.fileExtension || '').toLowerCase();
  if (mime === 'application/octet-stream' || !mime) {
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'].indexOf(ext) !== -1) mime = 'image/' + ext;
    else if (['mp4', 'avi', 'mov', 'mkv', 'webm'].indexOf(ext) !== -1) mime = 'video/' + ext;
    else if (['mp3', 'wav', 'ogg', 'flac', 'aac'].indexOf(ext) !== -1) mime = 'audio/' + ext;
    else if (['zip', '7z', 'rar', 'gz', 'tar'].indexOf(ext) !== -1) mime = 'application/zip';
    else if (['pdf'].indexOf(ext) !== -1) mime = 'application/pdf';
    else if (['doc', 'docx'].indexOf(ext) !== -1) mime = 'application/msword';
    else if (['xls', 'xlsx'].indexOf(ext) !== -1) mime = 'application/vnd.ms-excel';
    else if (['ppt', 'pptx'].indexOf(ext) !== -1) mime = 'application/vnd.ms-powerpoint';
    else if (['csv'].indexOf(ext) !== -1) mime = 'text/csv';
    else if (['js', 'ts', 'json', 'xml', 'html', 'css', 'py', 'php', 'rb', 'java', 'c', 'cpp', 'h'].indexOf(ext) !== -1) mime = 'text/x-code';
    else if (['txt', 'md', 'log', 'rtf'].indexOf(ext) !== -1) mime = 'text/plain';
  }

  for (var i = 0; i < ICON_MAP.length; i++) {
    if (ICON_MAP[i].test(mime)) {
      return { iconClass: 'fa ' + ICON_MAP[i].icon, color: ICON_MAP[i].color };
    }
  }

  return { iconClass: 'fa ' + DEFAULT_ICON.icon, color: DEFAULT_ICON.color };
}

export { getFileIconInfo };
